import React from 'react';

export default function RestrictedAccessPage() {
  return (
    <p>You do not have permissions to access this page.</p>
  );
}
